import { useMutation } from '@tanstack/react-query';

import { useSupabase } from './use-supabase';

export function useSignInWithSSO() {
  const client = useSupabase();

  const mutationFn = async (params: { domain: string; redirectTo: string }) => {
    console.log('[SSO] Starting sign-in', {
      domain: params.domain,
      redirectTo: params.redirectTo,
    });

    const response = await client.auth.signInWithSSO({
      domain: params.domain,
      options: { redirectTo: params.redirectTo },
    });

    if (response.error) {
      console.error('[SSO] signInWithSSO error', {
        message: response.error.message,
        status: response.error.status,
        code: (response.error as { code?: string }).code,
      });

      throw response.error;
    }

    console.log('[SSO] signInWithSSO success', {
      hasUrl: !!response.data.url,
      url: response.data.url?.substring(0, 80),
    });

    if (response.data.url) {
      window.location.href = response.data.url;
    }

    return response.data;
  };

  return useMutation({
    mutationFn,
    mutationKey: ['auth', 'sign-in-with-sso'],
  });
}
